import React, { Component } from "react";

// Elements
import SliderOneSection from "../elements/home-slider";
import PartnerShipsSection from "../elements/partnerships";
import AboutUsForIndex from "../elements/about-us-index";
import { Helmet } from "react-helmet-async";

class Index extends Component {
  render() {
    return (
      <>
        <Helmet>
          <title>Välkommen till KBS Center- Din Bilverkstad i Kungälv</title>
        </Helmet>
        <SliderOneSection />
        <AboutUsForIndex />
        <PartnerShipsSection />
      </>
    );
  }
}

export default Index;
